import { IMAGES, SITE } from "../lib/site";
import { Reveal } from "./Reveal";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full bg-[#F9F9F6] overflow-hidden grain"
    >
      {/* Background image with editorial overlay */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Equestrian rider in competition"
          className="w-full h-full object-cover anim-reveal"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B22]/55 via-[#1A2B22]/25 to-[#1A2B22]/65" />
      </div>

      {/* Top meta */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 pt-28 md:pt-32">
        <div className="flex justify-between items-center text-[11px] uppercase tracking-[0.32em] text-[#F9F9F6]/85">
          <span data-testid="hero-meta-location">{SITE.location}</span>
          <span className="hidden sm:inline">Est. 2026 — Czech Warmbloods</span>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 pt-20 md:pt-28 pb-24">
        <Reveal>
          <h1
            data-testid="hero-headline"
            className="font-display text-[14vw] md:text-[10vw] lg:text-[8.5vw] leading-[0.88] tracking-tighter text-[#F9F9F6] max-w-[14ch] text-balance"
          >
            Bred to <em className="italic font-normal">jump.</em>
            <br />
            Trained to <em className="italic font-normal">win.</em>
          </h1>
        </Reveal>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <Reveal delay={150} className="md:col-span-5 md:col-start-7">
            <p className="text-[#F9F9F6]/85 text-base md:text-lg leading-relaxed max-w-md">
              SPJ Sporthorses imports, develops, and brokers premium Czech
              Warmbloods for hunter, jumper, and equitation riders — from
              Coconut Creek to the world stage.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-3 px-7 py-4 bg-[#F9F9F6] text-[#1A2B22] text-xs uppercase tracking-[0.24em] hover:bg-[#965C3B] hover:text-[#F9F9F6] transition-colors duration-300"
              >
                Start an Inquiry
                <span aria-hidden>→</span>
              </a>
              <a
                href="#services"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-3 px-7 py-4 border border-[#F9F9F6]/60 text-[#F9F9F6] text-xs uppercase tracking-[0.24em] hover:bg-[#F9F9F6] hover:text-[#1A2B22] transition-colors duration-300"
              >
                Our Services
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Bottom hairline meta */}
      <div className="absolute bottom-0 inset-x-0 z-10 px-6 md:px-12 lg:px-24 pb-8 border-t border-[#F9F9F6]/15">
        <div className="pt-6 flex flex-col md:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.3em] text-[#F9F9F6]/70">
          <span>Show Jumping · Hunters · Equitation</span>
          <span className="hidden md:inline">Scroll ↓</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
